import styled, { css } from 'styled-components';
import { mediaMixin, Text, token } from '@zillow/constellation';

export const ClaimListingCardContainer = styled.div`
    border-top: 1px solid ${token('colors.gray300')};
    border-bottom: 1px solid ${token('colors.gray300')};

    ${mediaMixin('md', css`
        overflow-y: auto;
        max-height: 940px;
    `)}
`;

export const StyledContactMethodText = styled(Text)`
    && {
        font-weight: 700;
        display: inline-block;
    }
`;
